<template>
  <div id="full-wrapper">
    <router-view v-bind:navbar-height="navbarHeight"></router-view>
    <the-footer v-if="showFooter"></the-footer>
    <div class="toast-wrapper">
      <b-toast id="my-toast" variant="success" solid>
        <div slot="toast-title" class="d-flex flex-grow-1 align-items-baseline">
          <strong class="mr-auto">Thanks!</strong>
        </div>
        <p>We will get back to you with a response as soon as possible.</p>
      </b-toast>
    </div>
  </div>
</template>

<script>
import TheNavbar from './components/TheNavbar.vue'
import TheFooter from './components/TheFooter.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  data () {
    return {
      navbarHeight: 90
    }
  },
  metaInfo: {
    titleTemplate: (titleChunk) => {
      return titleChunk ? `${titleChunk} | HomApt` : 'HomApt'
    }
  },
  components: {
    TheNavbar: TheNavbar,
    TheFooter: TheFooter
  },
  computed: {
    ...mapGetters([
      'getIdProvider',
      'getSecretAccessKey'
    ]),
    showFooter () {
      if (this.$route.path === '/propertysearch' && Object.keys(this.$route.query).length > 0) {
        if (this.$route.query.search) return false
        return true
      } else {
        return true
      }
    }
  },
  methods: {
    ...mapActions([
      'unauthenticatedLogin'
    ]),
    ...mapMutations([
      'updateCognitoId',
      'updateAccessKeyId',
      'updateSecretAccessKey',
      'updateSessionToken',
      'updateExpireTime'
    ]),
    updateNavbarHeight (value) {
      this.navbarHeight = value
    }
  },
  async created () {
    if (!this.getSecretAccessKey) await this.unauthenticatedLogin()
    var that = this
    function getNotifications () {
      setTimeout(() => {
        that.$store.dispatch('user/getNotifications')
        getNotifications()
      }, 300000)
    }
    getNotifications()
    this.$store.dispatch('user/getNotifications')
    this.$store.dispatch('refreshLogin')
  }
}
</script>

<style>
/*This gets rid of the ugly white bar that shows up on the side of ios devices and messes up scrolling */

pre {
  background-color: #f8f8f8 !important;
  border: 1px solid #dfdfdf !important;
  padding: 0.125rem 0.3125rem 0.0625rem !important;
}

a {
   text-decoration: none !important;
   outline: 0 !important;
}

h1, h2, h3, h4, h5, h6, p, th, td {
  color:#4f4f4f !important;
}

/*This is used in conjunction with the css and javascript in the footer component to make sure
that the footer always stays at the bottom and doesnt float above the bottom of the window
this feature is diabled on ios devices but it will be ok most of the time because ios devices
are usually small enough that the footer wont look bad */
@supports not (-webkit-overflow-scrolling: touch) {
  html, body {
    height: 100%;
  }
}

@media (min-width: 1500px) {
    .container{
        max-width: 1400px;
    }
}

#full-wrapper {
  min-height:100%;
  position:relative;
}

:root {
  --background-color: white;
  --secondary-background-color: #feedaa;
  --navbar-color: white;
  --title-color: black;
  --text-color: gray;
  --dark-color: #363e4a;
  --bootstrap-sm: 570px;
  --bootstrap-md: 768px;
  --bootstrap-lg: 992px;
  --bootstrap-xl: 1200px;
}

img {
  max-width: 100% !important;
}

.btn {
  border-radius: 10px !important;
  box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.2) !important;
}

.btn:active {
  box-shadow: none !important;
}

.btn-primary {
  border: none !important;
  padding-top: 10px !important;
  padding-bottom: 11px !important;
  border: none !important;
  font-size: 1rem !important;
  width: 100% !important;
  color: black !important;
}

.btn-secondary {
  border: none !important;
  padding-top: 10px !important;
  padding-bottom: 11px !important;
  border: none !important;
  font-size: 1rem !important;
  background-color: #748096 !important;
}

.btn-secondary:hover {
  background-color: gray !important;
}

.btn-primary {
  background-color: var(--secondary-background-color) !important;
}

.btn:focus,.btn:active {
   outline: none !important;
   box-shadow: none;
}

.btn-primary:hover {
  background-color: #e59400 !important;
}

.card {
  box-shadow: 4px 4px 3px #888888 !important;
}

.homapt-expandable {
  -webkit-transition-property: transform; /* Safari */
  -webkit-transition-duration: .2s; /* Safari */
  transition-property: transform;
  transition-duration: .2s;
}

/*.homapt-expandable:hover {
  transform:scale(1.05);
}*/

/* TODO look at this */
body.modal-open {
  overflow: hidden !important;
  position: relative !important;
  -webkit-overflow-scrolling: touch !important;
}

.homapt-header {
  height: 40vh !important;
  background-size: cover;
  background-position: center center !important;
}

@media (max-height: 1000px) {
  .homapt-header {
    height: 80vh !important;
  }
}

@media (max-width: 570px) {
  .homapt-header {
    height: 100vh !important;
  }
}

.dark-overlay {
  height: 100% !important;
  background: rgba(0, 0, 0, .35) !important;
}

.nav-link {
  font-size: 2rem;
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.jumbotron {
  background-color: var(--secondary-background-color) !important;
  margin-bottom: 0px !important;
}

.overlay-text {
  color: white !important;
}

/* colors */
.navbar {
  background-color: var(--navbar-color) !important;
}

.red-text {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/App.vue